var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { Text, Img } from '@zapier/design-system';
import { mediaQueries } from '../../constants';
const Styles = labelStyles('LogoBar', {
    root: css `
    margin: 0 auto;
    padding: 55px 25px 20px 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1280px;
  `,
    logosContainer: css `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    ${mediaQueries.tablet} {
      flex-direction: row;
    }
  `,
    logoContainer: css `
    margin-bottom: 30px;

    ${mediaQueries.tablet} {
      margin-bottom: 35px;

      &:not(:last-child) {
        margin-right: 50px;
      }
    }

    ${mediaQueries.desktop} {
      &:not(:last-child) {
        margin-right: 80px;
      }
    }
  `,
});
/**
 * @deprecated
 * This component has been deprecated. `LogoBarV2` should be used instead.
 */
export function LogoBar({ title, items }) {
    return (_jsxs("div", Object.assign({ css: Styles.root }, { children: [_jsx(Text, Object.assign({ color: "gray", margin: "0 0 35px 0", tag: "p", type: "paragraph3" }, { children: title })), _jsx("div", Object.assign({ css: Styles.logosContainer }, { children: items.map((_a, index) => {
                    var { logoUrl, companyName } = _a, restProps = __rest(_a, ["logoUrl", "companyName"]);
                    return (_jsx("div", Object.assign({ css: Styles.logoContainer }, { children: _jsx(Img, Object.assign({ alt: companyName, borderRadius: 0, src: logoUrl }, restProps)) }), index + logoUrl));
                }) }))] })));
}
//# sourceMappingURL=LogoBar.js.map